import { Box, Group, Paper, Stack, Text } from "@mantine/core";
import type * as React from "react";
import { PANEL_COLOR, PANEL_RADIUS, PANEL_SPACE } from "./tokens";

/**
 * A card with a gray header band (Figma "Widget"): white, `border/default`, 5px corners; the
 * band is `gray/1` with its title in `gray/8`; the body pads 15px and spaces its blocks 15px
 * apart. `aside` sits at the band's right end. The add-in's SectionCard, at panel scale.
 */
export function SectionCard({
  title,
  aside,
  children,
  gap = PANEL_SPACE.card,
}: {
  title: string;
  aside?: React.ReactNode;
  children: React.ReactNode;
  gap?: number;
}) {
  return (
    <Paper withBorder radius={PANEL_RADIUS.card} style={{ overflow: "hidden" }} component="section">
      <Group justify="space-between" wrap="nowrap" bg={PANEL_COLOR.fill} px={PANEL_SPACE.card} py={PANEL_SPACE.field}>
        <Text c={PANEL_COLOR.headerText} lh="normal">
          {title}
        </Text>
        {aside ? <Box>{aside}</Box> : null}
      </Group>
      <Stack gap={gap} p={PANEL_SPACE.card}>
        {children}
      </Stack>
    </Paper>
  );
}
